import { render, staticRenderFns } from "./FileChooserBox.vue?vue&type=template&id=8f5b0c5c&"
import script from "./FileChooserBox.vue?vue&type=script&lang=js&"
export * from "./FileChooserBox.vue?vue&type=script&lang=js&"
import style0 from "./FileChooserBox.vue?vue&type=style&index=0&id=8f5b0c5c&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports